"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.returnEventFunction = exports.setReceivedPath = exports.setReceivedValue = exports.setReceivedLabel = exports.setReceivedMessage = exports.setLabel = exports.setAction = exports.setCategory = exports.setEvent = exports.setFixedPipedObj = exports.setParamObj = void 0;

const setParamObj = paramObj => ({ ...paramObj
});

exports.setParamObj = setParamObj;

const setFixedPipedObj = obj => pipedObj => ({ ...pipedObj,
  ...obj
});

exports.setFixedPipedObj = setFixedPipedObj;

const setEvent = event => setFixedPipedObj({
  event
});

exports.setEvent = setEvent;

const setCategory = category => setFixedPipedObj({
  category
});

exports.setCategory = setCategory;

const setAction = action => setFixedPipedObj({
  action
});

exports.setAction = setAction;

const setLabel = label => setFixedPipedObj({
  label
});

exports.setLabel = setLabel;

const setReceivedMessage = message => setParamObj({
  message
});

exports.setReceivedMessage = setReceivedMessage;

const setReceivedLabel = label => setParamObj({
  label
});

exports.setReceivedLabel = setReceivedLabel;

const setReceivedValue = value => setParamObj({
  value
});

exports.setReceivedValue = setReceivedValue;

const setReceivedPath = path => setParamObj({
  path
});

exports.setReceivedPath = setReceivedPath;

const returnEventFunction = fn => () => param => fn(param);

exports.returnEventFunction = returnEventFunction;